(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@big-d-companies/animation"] = factory();
	else
		root["@big-d-companies/animation"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  useHeadingAnimationRaceConditionFix: () => (/* reexport */ use_heading_animation_race_condition_fix)
});

;// CONCATENATED MODULE: ./src/use-heading-animation-race-condition-fix.js
const DEFAULT_TIMEOUT_DURATION_IN_MILLISECONDS = 500;

/**
 * Codifies and encapsulates a "hacky" fix for the heading animations which
 * broke after upgrading Next.js to the latest version.
 *
 * The `setTimeout` call is necessary because the `SplitText` instance generated
 * within `useEffect` within the `Header` component is not available at the time
 * of calling `animateIn()` in the parent component.
 *
 * I've spent hours debugging this and cannot come up with a more reasonable solution,
 * so opted to create this hook to clearly indicate its necessity.
 */
const useHeadingAnimationRaceConditionFix = (headingRef, delay = DEFAULT_TIMEOUT_DURATION_IN_MILLISECONDS) => {
  const animateHeadingIn = () => {
    setTimeout(() => {
      headingRef?.current?.animateIn();
    }, delay);
  };
  return animateHeadingIn;
};
/* harmony default export */ const use_heading_animation_race_condition_fix = (useHeadingAnimationRaceConditionFix);
;// CONCATENATED MODULE: ./src/index.js


/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map